"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _drei = require("@react-three/drei");
var _reactErrorBoundary = require("react-error-boundary");
var _reactRedux = require("react-redux");
var _selectors = require("../../../redux/selectors");
var _PointLight = _interopRequireDefault(require("../../Viewer/Lights/PointLight"));
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../../utils/constants");
const _excluded = ["debug"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const DistrictHeatingModelContent = props => {
  const {
      debug = {}
    } = props,
    p = _objectWithoutProperties(props, _excluded);
  const {
    source
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const {
    nodes,
    materials
  } = (0, _drei.useGLTF)("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/311_district_heating.glb"));
  const [showHelper, setShowHelper] = (0, _react.useState)(false);
  const [showItem, setShowItem] = (0, _react.useState)(true);
  const shadows = {
    castShadow: true,
    receiveShadow: false
  };
  const debugModeStatus = (0, _reactRedux.useSelector)(_selectors.getDebugModeStatus);
  const {
    name = 'DistrictHeatingModel',
    showDebug = true
  } = debug;
  const DistrictHeatingRef = (0, _react.useRef)(null);

  // const {helper, display, ...controlP} = useControls(
  //     name, {...p, helper: showHelper, display: showItem}, {collapsed: true}
  // );
  // useEffect(() => {
  //     setShowHelper(showDebug && helper)
  // }, [helper, showDebug])
  //
  // useEffect(() => {
  //     setShowItem(display)
  // }, [display])
  //
  // useHelper(debugModeStatus && showHelper && WashbasinRef, BoxHelper, 'red')
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("group", _extends({
    ref: DistrictHeatingRef,
    dispose: null,
    visible: true
  }, p), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['01_base_wall'].geometry,
    material: materials['Component.WhiteObjects']
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['02_heatlight_source'].geometry,
    material: materials['Tubes.EmissionWarmwasser'],
    position: [-2, 0, 0]
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['03_attach_points'].geometry,
    material: materials['Component.WhiteDefault'],
    position: [1, 0, 0]
  }, shadows)), /*#__PURE__*/_react.default.createElement(_PointLight.default, {
    color: "#ff3E41",
    position: [-5, -8, 0],
    distance: 20,
    castShadow: true,
    debug: _objectSpread(_objectSpread({}, debug), {}, {
      showGlobalLightHelper: false,
      debugModeStatus: false,
      name: 'Lights.Point Light.2'
    })
  })), [p, nodes, materials, shadows]);
};
const DistrictHeatingModel = (0, _reactErrorBoundary.withErrorBoundary)(DistrictHeatingModelContent, {
  FallbackComponent: () => null,
  onError: (err, info) => console.error(err, info)
});
var _default = exports.default = DistrictHeatingModel;